import { therapyPlanningAction } from '../../actions/constant';

const {
  UPDATE_THERAPY_PLANNING_FAILURE,
  UPDATE_THERAPY_PLANNING_SUCCESS,
  RESET_UPDATE_THERAPY_PLANNING_REQUEST,
  UPDATE_THERAPY_PLANNING_LOADING,
} = therapyPlanningAction;

const intitialstate: object = {
  isTherapyPlanningUpdated: false,
  response: null,
  loading: false,
};

export const updateTherapyPlanningReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case UPDATE_THERAPY_PLANNING_SUCCESS: {
      return {
        ...state,
        isTherapyPlanningUpdated: true,
        response: action.payload,
        loading: false,
      };
    }

    case UPDATE_THERAPY_PLANNING_FAILURE:
      return {
        ...state,
        isTherapyPlanningUpdated: false,
        response: action.payload,
        loading: false,
      };
    case UPDATE_THERAPY_PLANNING_LOADING:
      return {
        ...state,
        loading: true,
      };

    case RESET_UPDATE_THERAPY_PLANNING_REQUEST:
      return intitialstate;

    default:
      return state;
  }
};
